export default "__VITE_ASSET__7j3n7RqB__"